/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMoneyPoolWithOptions} from '../api'

 export const useQueryGetMoneyPoolWithOptions = createReactQueryHook('getMoneyPoolWithOptions', getMoneyPoolWithOptions)
